export default __webpack_public_path__ + "static/media/bitplay.22aae7ba.svg";